export const RESET_SELECTED_TEMPLATE_FILE_ITEM_ACTION = 'RESET_SELECTED_TEMPLATE_FILE_ITEM_ACTION'
export const SELECT_TEMPLATE_FILE_ITEM_ACTION = 'SELECT_TEMPLATE_FILE_ITEM_ACTION'
export const RESET_SELECTED_DESTINATION_FOLDER_ITEM_ACTION = 'RESET_SELECTED_DESTINATION_FOLDER_ITEM_ACTION'
export const SELECT_DESTINATION_FOLDER_ITEM_ACTION = 'SELECT_DESTINATION_FOLDER_ITEM_ACTION'

export function setSelectedTemplateFileItem (item) {
  return {
    type: SELECT_TEMPLATE_FILE_ITEM_ACTION,
    item
  }
}

export function resetSelectedTemplateFileItem () {
  return {
    type: RESET_SELECTED_TEMPLATE_FILE_ITEM_ACTION
  }
}

export function setSelectedDestinationFolderItem (item) {
  return {
    type: SELECT_DESTINATION_FOLDER_ITEM_ACTION,
    item
  }
}

export function resetSelectedDestinationFolderItem () {
  return {
    type: RESET_SELECTED_DESTINATION_FOLDER_ITEM_ACTION
  }
}
